import React, { useEffect, useContext, useState } from 'react';
import Button from '@mui/material/Button';
import { TextInput, SelectBox, ToastEditor, FileMultipleUploader, TextViewer } from '../../components';
import { useForm } from '../../hooks';
import { SnackbarContext, DialogContext } from '../../contexts';
import Handler from '../../Handler';
import API from '../../api';
import _ from 'lodash';
import { useHistory, useParams } from 'react-router-dom';

export const CsFaqDetailPage = (props) => {
  const history = useHistory();
  const { slug } = useParams();
  const { updateSnackbar } = useContext(SnackbarContext);
  const { dialog, updateDialog } = useContext(DialogContext);
  const [initData, setInitData] = useState(false);
  const [formData, formMeta, formChange, setFormData, setFormMeta] = useForm(
    {
      site: '',
      category: '',
      title: '',
      content: '',
      fileArray: [],
    },
    {
      site: {
        key: 'site',
        label: '사이트',
        fullWidth: true,
        required: true,
        menus: [
          {
            value: 'Credit',
            label: '인증시스템',
          },
          {
            value: 'Market',
            label: '마켓플레이스',
          },
        ],
      },
      category: {
        key: 'category',
        label: '카테고리',
        fullWidth: true,
        required: true,
        menus: [],
      },
      title: {
        key: 'title',
        label: '제목',
        fullWidth: true,
        required: true,
      },
      content: {
        key: 'content',
        label: '내용',
        required: true,
        path: 'editor/faq',
        id: 'faq',
      },
      fileArray: {
        type: 'file',
        key: 'fileArray',
        label: '파일 첨부',
        path: '/faq/file',
        max: 1,
      },
    },
  );
  const [categoryInfo, setCategoryInfo] = useState(null);
  const [categoryHold, setCategoryHold] = useState(false); //초기 렌더링시에 category useEffect로 사라지는거 방지;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.CS.GetFaqInfo().then(
      (res) => {
        console.log('GetFaqInfo res', res);
        let result = res.data;
        setCategoryInfo(result);
      },
      (err) => {
        updateSnackbar({
          type: 'error',
          open: true,
          message: err.data.message,
        });
      },
    );
  }, []);

  useEffect(() => {
    let current_site = formData.site;
    if (current_site) {
      console.log('current_stie', current_site);
      let new_formMeta = _.clone(formMeta);
      console.log('new_formMeta', new_formMeta);
      let category_menus = Handler.buildCategoryMenus(categoryInfo, current_site, false);
      new_formMeta.category.menus = category_menus;
      setFormMeta(new_formMeta);
      console.log('categoryHold', categoryHold);
      if (!categoryHold) {
        formChange(null, 'category');
      } else {
        setCategoryHold(false);
      }
    }
  }, [formData.site]);

  useEffect(() => {
    if (slug) {
      refreshData();
    }
  }, [slug]);

  useEffect(() => {
    if ((initData, categoryInfo)) {
      console.log('initData', initData);
      setCategoryHold(true);
      setFormData({
        site: initData.site,
        category: initData.category,
        title: initData.title,
        content: initData.content,
        fileArray: initData.files,
      });
    }
  }, [initData, categoryInfo]);

  const refreshData = () => {
    API.CS.GetFaqDetail(slug).then(
      (res) => {
        let result = res.data;
        setInitData(result);
        setLoading(false);
      },
      (err) => {
        console.log('err', err);
        updateSnackbar({
          type: 'error',
          open: true,
          message: err.data.message,
        });
        setLoading(false);
      },
    );
  };

  const requsetSave = () => {
    let body = Handler.formToBody(formData, formMeta);
    console.log(body.content);
    // return;
    if (body) {
      API.CS.PutFaq(slug, body).then(
        (res) => {
          let result = res.data;
          console.log('PutFaq post result', result);
          refreshData();
          updateSnackbar({
            type: 'success',
            open: true,
            message: '저장 성공',
          });
        },
        (err) => {
          updateSnackbar({
            type: 'error',
            open: true,
            message: err.data.message,
          });
        },
      );
    } else {
      updateSnackbar({
        type: 'error',
        open: true,
        message: '필수정보를 확인하세요',
      });
    }
  };

  const requsetDelete = () => {
    console.log('requsetDelete');
    API.CS.DeleteFaq(slug).then(
      (res) => {
        let result = res.data;
        console.log('DeleteFaq post result', result);
        history.push('/cs/faq/list');
      },
      (err) => {
        updateSnackbar({
          type: 'error',
          open: true,
          message: err.data.message,
        });
      },
    );
  };

  //   console.log('[RENDER] content');
  //   console.log(formData.content);

  if (loading) {
    return null;
  }

  return (
    <article className='basic-page'>
      <section className='content-header__container'>
        <header>
          <h3>FAQ 카테고리 상세</h3>
        </header>
        <div className='button__box'>
          <Button
            variant='contained'
            color='secondary'
            disabled={false}
            onClick={() => {
              updateDialog({
                type: 'error',
                open: true,
                title: 'FAQ 카테고리 삭제',
                description: '삭제 후 되돌릴 수 없습니다. 그래도 진행하시겠습니까?',
                onConfirm: requsetDelete,
              });
            }}
          >
            삭제
          </Button>
          <Button disabled={false} variant='contained' onClick={requsetSave}>
            저장
          </Button>
        </div>
      </section>
      <section className='form__container'>
        <header>
          <h3>기본 정보</h3>
        </header>
        <div className='flex'>
          <SelectBox value={formData.site} onChange={formChange} meta={formMeta.site}></SelectBox>
          <SelectBox value={formData.category} onChange={formChange} meta={formMeta.category}></SelectBox>
          <TextInput value={formData.title} onChange={formChange} meta={formMeta.title}></TextInput>
          <ToastEditor value={formData.content} onChange={formChange} meta={formMeta.content}></ToastEditor>
          <FileMultipleUploader
            value={formData.fileArray}
            onChange={formChange}
            meta={formMeta.fileArray}
          ></FileMultipleUploader>
          <TextViewer
            value={formData.adminId ? formData.adminId : ''}
            meta={{
              label: '어드민 ID',
              render: (value) => {
                return value;
              },
            }}
          ></TextViewer>
        </div>
      </section>
    </article>
  );
};
